import { useState } from "react";
import React from "react";

import Button from "react-bootstrap/Button";
import Table from "react-bootstrap/Table";
import getDataSummary from "../Functions/getDataSummary";


let sectionData = {
  maths: {
    correct: 0, wrong: 0, attempted: 0, marks: 0,
  },
  logical: {
    correct: 0, wrong: 0, attempted: 0, marks: 0,
  },
  computer: {
    correct: 0, wrong: 0, attempted: 0, marks: 0,
  },
  english: {
    correct: 0, wrong: 0, attempted: 0, marks: 0,
  },
  overall: {
    correct: 0, wrong: 0, attempted: 0, marks: 0,
  },
}

class SummaryTable extends React.Component {
  render() {
    return (
      <div>
        <div className="text-left my-1 mb-5">
          <Button
            id="submit-btn"
            onClick={() => {
              sectionData = getDataSummary();
              this.props.handler();
            }}
          >
            Submit
          </Button>
        </div>

        <div style={{visibility: this.props.display}} id="result-table" className="container">
          <Table bordered striped>
            <thead>
              <tr>
                <th>Subject</th>
                <th>No. of Questions</th>
                {/* <!-- <th>Marks For Right Answer</th>
              <th>Marks For Wrong Answer</th> --> */}
                <th>Attempted Qus</th>
                <th>Right Answered</th>
                <th>Wrong Answered</th>
                <th>Marks</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Mathematics</td>
                <td>50</td>
                {/* <!-- <td></td>
              <td></td> --> */}
                <td id="mq-attempt">{sectionData.maths.attempted}</td>
                <td id="mq-correct">{sectionData.maths.correct}</td>
                <td id="mq-wrong">{sectionData.maths.wrong}</td>
                <td id="m-marks">{sectionData.maths.marks}</td>
              </tr>
              <tr>
                <td>Logical Ability</td>
                <td>40</td>
                {/* <!-- <td></td>
              <td></td> --> */}
                <td id="lq-attempt">{sectionData.logical.attempted}</td>
                <td id="lq-correct">{sectionData.logical.correct}</td>
                <td id="lq-wrong">{sectionData.logical.wrong}</td>
                <td id="l-marks">{sectionData.logical.marks}</td>
              </tr>
              <tr>
                <td>Computer</td>
                <td>10</td>
                {/* <!-- <td></td>
              <td></td> --> */}
                <td id="cq-attempt">{sectionData.computer.attempted}</td>
                <td id="cq-correct">{sectionData.computer.correct}</td>
                <td id="cq-wrong">{sectionData.computer.wrong}</td>
                <td id="c-marks">{sectionData.computer.marks}</td>
              </tr>
              <tr>
                <td>English</td>
                <td>20</td>
                {/* <!-- <td></td>
              <td></td> --> */}
                <td id="eq-attempt">{sectionData.english.attempted}</td>
                <td id="eq-correct">{sectionData.english.correct}</td>
                <td id="eq-wrong">{sectionData.english.wrong}</td>
                <td id="e-marks">{sectionData.english.marks}</td>
              </tr>
              <tr>
                <td>Total Qus</td>
                <td>120</td>
                {/* <!-- <td></td>
              <td></td> --> */}
                <td id="total-attempt">{sectionData.overall.attempted}</td>
                <td id="total-correct">{sectionData.overall.correct}</td>
                <td id="total-wrong">{sectionData.overall.wrong}</td>
                <td id="total-marks">{sectionData.overall.marks}</td>
              </tr>
            </tbody>
          </Table>
        </div>
      </div>
    );
  }
}

export { SummaryTable };